import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from '../providers/user.service';

@Injectable()

export class SubscriberRoleGuardService implements CanActivate {

    constructor(private userService: UserService, private router: Router) { }

    canActivate() {
        const userHasSubscriberRole = this.userService.userHasRole('ROLE_SUBSCRIBER');

        if (!userHasSubscriberRole) {
            this.router.navigate(['/home']);

            return;
        }

        return true;
    }
}
